


    <div id="dvamxprint"></div>




 


<!-- <div class="row settings-box">
  <div class="col-md-11">
    <h4><b>Printing</b></h4>
  </div>
</div>

<div class="row">

  <div class="col-md-8 padd-3">
    <div class="row">
      <div class="col-md-4 col-sm-12 col-xs-12">
        <div class="form-group">
          <label class="label-control">Receipt Label Type</label>
          <select class="form-control"
                  (change)="emitSetttings()"
                  [ngModel]="defaultSettings?.ReceiptType"
                  (ngModelChange)="defaultSettings.ReceiptType = $event" disabled>
            <option *ngFor="let i of reports?.receiptReport.reports" value="{{i.ReportId}}">{{i.Description}}</option>
          </select>
        </div>
      </div>
      <div class="col-md-4">
        <div class="row">
          <div class="col-md-4 col-sm-6 col-xs-6">
            <div class="form-group">
              <label class="label-control">Copies</label>
              <input [(ngModel)]="printingSettings.ReceiptLabelType.compies" class="form-control" type="number" min="1" />
            </div>
          </div>
          <div class="col-md-8 col-sm-6 col-xs-6">
            <div class="form-group">
              <label class="label-control">Printers</label>
              <select class="form-control" [(ngModel)]="printingSettings.ReceiptLabelType.printer">
                <option value="0">Select</option>
                <option *ngFor="let printer of printers" value="{{printer}}">{{printer}}</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-4 col-sm-12 col-xs-12">
        <div class="form-group">
          <label class="label-control"> Tax Receipt Label Type</label>
          <select class="form-control"
                  (change)="emitSetttings()"
                  [ngModel]="defaultSettings?.TaxInvoiceType"
                  (ngModelChange)="defaultSettings.TaxInvoiceType = $event" disabled>
            <option *ngFor="let i of reports?.taxInvoicesReport.reports" value="{{i.ReportId}}">{{i.Description}}</option>
          </select>
        </div>
      </div>
      <div class="col-md-4">
        <div class="row">
          <div class="col-md-4 col-sm-6 col-xs-6">
            <div class="form-group">
              <label class="label-control">Copies</label>
              <input class="form-control" [(ngModel)]="printingSettings.TaxReceiptLabelType.compies" type="number" min="1" />
            </div>
          </div>
          <div class="col-md-8 col-sm-6 col-xs-6">
            <div class="form-group">
              <label class="label-control">Printers</label>
              <select class="form-control" [(ngModel)]="printingSettings.TaxReceiptLabelType.printer">
                <option value="0">Select</option>
                <option *ngFor="let printer of printers" value="{{printer}}">{{printer}}</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 col-sm-12 col-xs-12">
        <div class="form-group">
          <label class="label-control"> Cashier out Report</label>
          <select class="form-control"
                  (change)="emitSetttings()"
                  [ngModel]="defaultSettings?.CashOutReportType"
                  (ngModelChange)="defaultSettings.CashOutReportType = $event" disabled>

            <option *ngFor="let i of reports?.cashoutsReport.reports" value="{{i.ReportId}}">{{i.Description}}</option>
          </select>
        </div>
      </div>
      <div class="col-md-4">
        <div class="row">
          <div class="col-md-4 col-sm-6 col-xs-6">
            <div class="form-group">
              <label class="label-control">Copies</label>
              <input class="form-control" [(ngModel)]="printingSettings.CashierOutReport.compies" type="number" min="1" />
            </div>
          </div>
          <div class="col-md-8 col-sm-6 col-xs-6">
            <div class="form-group">
              <label class="label-control">Printers</label>
              <select class="form-control" [(ngModel)]="printingSettings.CashierOutReport.printer">
                <option value="0">Select</option>
                <option *ngFor="let printer of printers" value="{{printer}}">{{printer}}</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 col-sm-12 col-xs-12">
        <div class="form-group">
          <b>Waybill Form</b>
          <select class="form-control"
                  (change)="emitSetttings()"
                  [ngModel]="defaultSettings?.LabelType"
                  (ngModelChange)="defaultSettings.LabelType = $event" disabled>
            <option *ngFor="let i of reports?.labelReport.reports" value="{{i.ReportId}}">{{i.Description}}</option>
          </select>
        </div>
      </div>
      <div class="col-md-4">
        <div class="row">
          <div class="col-md-4 col-sm-6 col-xs-6">
            <div class="form-group">
              <label class="label-control">Copies</label>
              <input class="form-control" [(ngModel)]="printingSettings.Waybillform.compies" type="number" min="1" />
            </div>
          </div>
          <div class="col-md-8 col-sm-6 col-xs-6">
            <div class="form-group">
              <label class="label-control">Printers</label>
              <select class="form-control" [(ngModel)]="printingSettings.Waybillform.printer">
                <option value="0">Select</option>
                <option *ngFor="let printer of printers" value="{{printer}}">{{printer}}</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row" *ngIf="allowPrintingMultipleLabels">
      <div class="col-md-4 col-sm-12 col-xs-12">
        <div class="form-group">
          <label class="label-control">Second Waybill Form</label>
          <select class="form-control"
                  (change)="emitSetttings()"
                  [ngModel]="defaultSettings?.SecondLabelType"
                  (ngModelChange)="defaultSettings.SecondLabelType = $event" disabled>
            <option *ngFor="let i of reports?.labelReport.reports" value="{{i.ReportId}}">{{i.Description}}</option>
          </select>
        </div>
      </div>
      <div class="col-md-4">
        <div class="row">
          <div class="col-md-4">
            <div class="form-group">
              <label class="label-control">Copies</label>
              <input class="form-control" [(ngModel)]="printingSettings.SecondLabelType.compies" type="number" min="1" />
            </div>
          </div>
          <div class="col-md-8 col-sm-6 col-xs-6">
            <div class="form-group">
              <label class="label-control">Printers</label>
              <select class="form-control" [(ngModel)]="printingSettings.SecondLabelType.printer">
                <option value="0">Select</option>
                <option *ngFor="let printer of printers" value="{{printer}}">{{printer}}</option>
              </select>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>

</div>

<div class="row">
  <div class="col-md-4 pull-right">
    <div class="form-group">
      <button class="btn btn-primary full-width" (click)="saveUserPrintingSettings()">Save</button>
    </div>
  </div>
</div>

<div class="row">
  <div class="col-md-12">
    <h4><i class="armx-download"></i> Download the agent by clicking <a class="down-btn" href="https://www.aramex.com/content/uploads/100/55/mypos/myposagent.zip">Here</a></h4>
  </div>

</div> -->
